/** data-testid catalogue. */

export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  root: "landing-page",
  ctaLogin: "landing-cta-login",
  ctaSignup: "landing-cta-signup",
  ctaExplore: "landing-cta-explore-courses",
  whatsappBtn: "landing-whatsapp-btn",
  navLogin: "landing-nav-login",
  navGetStarted: "landing-nav-getstarted",
};

export const AUTH = {
  loginRoot: "login-page",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginRemember: "login-remember-check",
  loginSubmit: "login-submit-button",
  loginToSignup: "login-to-signup-link",
  loginToForgot: "login-to-forgot-link",
  loginError: "login-error-alert",

  signupRoot: "signup-page",
  signupFirst: "signup-firstname-input",
  signupLast: "signup-lastname-input",
  signupEmail: "signup-email-input",
  signupMobile: "signup-mobile-input",
  signupPassword: "signup-password-input",
  signupConfirm: "signup-confirm-input",
  signupSubmit: "signup-submit-button",
  signupToLogin: "signup-to-login-link",
  signupError: "signup-error-alert",

  forgotRoot: "forgot-page",
  forgotEmail: "forgot-email-input",
  forgotSubmit: "forgot-submit-button",
  forgotSuccess: "forgot-success-alert",

  resetRoot: "reset-page",
  resetPassword: "reset-password-input",
  resetConfirm: "reset-confirm-input",
  resetSubmit: "reset-submit-button",
  resetSuccess: "reset-success-alert",

  otpRoot: "otp-page",
  otpInput: "otp-input",
  otpSubmit: "otp-submit-button",
  otpResend: "otp-resend-button",
};

export const DASH = {
  root: (r) => `dashboard-${r}`,
  sidebar: "dashboard-sidebar",
  sidebarLink: (label) => `sidebar-link-${label}`,
  topbar: "dashboard-topbar",
  userMenu: "topbar-user-menu",
  userMenuButton: "topbar-user-menu-btn",
  logoutBtn: "topbar-logout-btn",
  profileLink: "topbar-profile-link",
  changePwdLink: "topbar-changepwd-link",
  settingsLink: "topbar-settings-link",
  mobileMenuToggle: "topbar-mobile-toggle",
  statCard: (key) => `stat-card-${key}`,
};

export const SETTINGS = {
  profileRoot: "profile-page",
  profileFirst: "profile-firstname-input",
  profileLast: "profile-lastname-input",
  profileMobile: "profile-mobile-input",
  profileDesignation: "profile-designation-input",
  profileSave: "profile-save-button",

  cpRoot: "change-password-page",
  cpCurrent: "cp-current-input",
  cpNew: "cp-new-input",
  cpConfirm: "cp-confirm-input",
  cpSubmit: "cp-submit-button",

  accountRoot: "account-settings-page",
};

export const ERRORS = {
  unauthorized: "unauthorized-page",
  notFound: "not-found-page",
  homeLink: "error-home-link",
};
